import type { DrilldownQuerySection } from "@/lib/queries/drilldown.queries"
import type { DrilldownPageFiltersInput } from "@/lib/queries/drilldown.queries"
import type { MyBrandFiltersInput } from "@/lib/queries/dashboard.queries"

const MAX_ENTRIES = 5

const lruCache = new Map<string, DrilldownQuerySection>()

export function myBrandDrawerCacheKey(
  hash: string,
  filters: MyBrandFiltersInput,
  drilldownFilters: DrilldownPageFiltersInput,
): string {
  return `${hash}|${JSON.stringify({ filters, drilldownFilters })}`
}

export function peekCachedMyBrandDrawerData(key: string): DrilldownQuerySection | undefined {
  return lruCache.get(key)
}

export function touchCachedMyBrandDrawerData(key: string): void {
  const hit = lruCache.get(key)
  if (!hit) return
  lruCache.delete(key)
  lruCache.set(key, hit)
}

export function setCachedMyBrandDrawerData(key: string, section: DrilldownQuerySection): void {
  if (lruCache.has(key)) lruCache.delete(key)
  lruCache.set(key, section)
  while (lruCache.size > MAX_ENTRIES) {
    const oldest = lruCache.keys().next().value
    if (oldest === undefined) break
    lruCache.delete(oldest)
  }
}

export function clearMyBrandDrawerDataCacheForTests(): void {
  lruCache.clear()
}
